<app-toolbar-shell class="toolbar-con">
  <kin-mode-switch
    class="toolbar-item-wide"
    displayType="text"
    size="medium"
    textLeft="Cacher le podium"
    textRight="Afficher le podium"
    lightColor="black"
    darkColor="white"
    [active]="showRankingBlock()"
    [displayBorder]="true"
    (switchClick)="showRankingBlock.set($event)" />
  <kin-select
    class="toolbar-item-wide"
    name="value-select"
    [value]="contestService.selectedMetric()"
    (onSelectedValue)="selectedMetricChange($event)">
    @for (value of store.metricOptions(); track value.id) {
      <option [value]="value.id">
        {{ value.label }}
      </option>
    }
  </kin-select>

  @if (contestService.selectedMetric() === 'ppr') {
    <kin-select
      name="ppr-select"
      [value]="store.pprFilter().toString()"
      (onSelectedValue)="pprFilterChange($event)">
      @for (time of pprTimes; track $index) {
        <option [value]="time">PPR {{ time >= 60 ? time / 60 + 'min' : time + 'sec' }}</option>
      }
    </kin-select>
  }

  <kin-select
    name="gender-select"
    [value]="store.targetGender()"
    (onSelectedValue)="genderChange($event)">
    <option selected value="">Homme & Femme</option>
    <option value="maleDisplay">Homme</option>
    <option value="femaleDisplay">Femme</option>
  </kin-select>
  @if (loginService.isLogged()) {
    @if (contestService.canManageContest()) {
      <kin-btn (onClick)="openRequiredEmailModal()" [disabled]="exportLoading"> exporter </kin-btn>
      <kin-btn (onClick)="openResetConfirmModal()" [disabled]="resetLoading"> reset </kin-btn>
      <kin-checkbox
        inputId="editionMode"
        name="editionMode"
        size="medium"
        [checked]="editionModeEnabled()"
        (change)="enableEditionMode($event)">
        Mode édition
      </kin-checkbox>
    }
    <kin-btn color="light" class="login-btn" (onClick)="openLogoutModal()">
      Se Deconnecter
    </kin-btn>
  } @else {
    <kin-btn class="login-btn" (onClick)="loginService.redirectToOauth()"> Se Connecter </kin-btn>
  }
</app-toolbar-shell>
